import React from 'react';
import { StockAdviceReport } from '../types/stockAdvice';

interface StockScoreHeroProps {
  report: StockAdviceReport;
  cached: boolean;
}

const confidenceClass = (confidence: StockAdviceReport['confidence']) => {
  if (confidence === 'High') return 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30';
  if (confidence === 'Medium') return 'bg-amber-500/15 text-amber-300 border-amber-500/30';
  return 'bg-rose-500/15 text-rose-300 border-rose-500/30';
};

export const StockScoreHero: React.FC<StockScoreHeroProps> = ({ report, cached }) => (
  <section className="rounded-3xl border border-indigo-400/30 bg-gradient-to-r from-[#17172a] via-[#1a1a2f] to-[#121224] p-4 md:p-5">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="space-y-2">
        <div className="flex items-center gap-2"><span className="text-xs px-2 py-1 rounded-full border border-indigo-400/40 text-indigo-200">{report.symbol}</span><span className="text-xs text-slate-400">{report.exchange}</span></div>
        <h3 className="text-lg font-semibold text-white">AI Hedge Fund Scorecard · {report.name}</h3>
        <p className="text-sm text-indigo-100">{report.headline}</p>
        <p className="text-xs text-slate-400 max-w-3xl">{report.summary}</p>
      </div>
      <div className="text-right">
        <p className="text-xs text-slate-500">Overall Score</p>
        <p className="text-4xl font-bold text-white">{report.overallScore}</p>
        <div className="flex items-center gap-2 mt-2 justify-end">
          <span className={`text-[11px] px-2 py-1 rounded-full border ${confidenceClass(report.confidence)}`}>{report.confidence} confidence</span>
          {cached ? <span className="text-[11px] px-2 py-1 rounded-full border border-emerald-500/30 text-emerald-300">Cached</span> : null}
        </div>
      </div>
    </div>
  </section>
);
